export enum InvestmentsEventsActionsEnum {
  PAGE_VIEWED = 'page-viewed',
  BUTTON_CLICKED = 'button-clicked',
  CARD_CLICKED = 'card-clicked',
  BOTTOMSHEET_VIEWED = 'bottomsheet-viewed',
  TOAST_VIEWED = 'toast-viewed',
  DROPDOWN_CLICKED = 'dropdown-clicked',
  MODAL_VIEWED = 'modal-viewed',
  SUCCESSFULLY_DELETED = 'successfully-deleted'
}

export enum CommonMetadataEnum {
  OWNER = 'investimentos',
  PROJECT = 'stone',
  PRODUCT = 'cofrinhos'
}

export enum InvestmentsProductLabelEnum {
  COFRINHOS = 'cofrinhos',
  VITRINE = 'vitrine de investimentos'
}
